module.exports = __webpack_public_path__ + "static/media/portfolio.7ebe0bcc.svg";